export const GOOGLE_CAPTCHA_API_KEY = '6LcvlJ4UAAAAANR39p-gt3JbcczGQTwbaJtDXhTC';